import { Button, Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import styles from './CalendarSelect.module.scss';

interface CalendarPickerProps {
  days: number[];
  selectedDates: Set<number>;
  onDateClick: (day: number) => void;
  onClearAll: () => void;
}

const CalendarPicker = ({ days, selectedDates, onDateClick, onClearAll }: CalendarPickerProps) => {
  return (
    <div className={styles.picker} onClick={e => e.stopPropagation()}>
      <div className={styles.calendarContent}>
        <div className="flex items-center justify-between">
          <Typography variant="h4" color="var(--navi-color-gray-c1)">
            Choose a day of month
          </Typography>
          <Button variant="text" size="small" onClick={onClearAll}>
            Clear All
          </Button>
        </div>

        <div className={styles.calendarGrid}>
          {days.map(day => (
            <Button
              type="button"
              variant="text"
              size="small"
              key={day}
              onClick={() => onDateClick(day)}
              className={cx(styles.dayButton, {
                [styles.selected]: selectedDates.has(day)
              })}
            >
              <Typography variant="h5" color="var(--navi-color-gray-c1)">
                {day}
              </Typography>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarPicker;
